export enum TextTransform {
  None = 'none',
  Uppercase = 'uppercase',
}

export const TextTransforms = Object.values(TextTransform)
